import 'css-chunksrc/client/scenes/timeRecordRemoval/styles.scss';export default {
  "header": "_header_1pc9n_1",
  "group": "_group_1pc9n_5",
  "text": "_text_1pc9n_9",
  "name": "_name_1pc9n_14",
  "main": "_main_1pc9n_20",
  "buttons": "_buttons_1pc9n_27"
};